// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wda2VwJA7hkDwCGcB9Cj{position:relative;overflow:hidden}.DkicsE5faYKNAFrTkogF{width:100%;height:100%;display:flex;position:relative;overflow:hidden}.CNWtsohNKrEentjrpEin{flex-direction:column;width:100%;min-width:620px;max-width:620px;padding-top:30px;display:flex;overflow:hidden}.fIKTxisEdh0MWlbkgDuJ{flex-direction:column;gap:12px;padding:0 80px 12px;display:flex}.mLIYMWnnvy0Gh0zrw9sW{flex:1;min-height:0}.YP_gCHz2COU9tV8uP1l0{justify-content:flex-end;padding:32px 80px 64px;display:flex}.OW9G6hSsDs87oIjLvKlL{width:100%}.hEFkrjyh19g1hOPaquZe{border-left:1px solid var(--border-neutral-default);flex:1;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `wda2VwJA7hkDwCGcB9Cj`,
	"wrap": `DkicsE5faYKNAFrTkogF`,
	"main": `CNWtsohNKrEentjrpEin`,
	"header": `fIKTxisEdh0MWlbkgDuJ`,
	"formArea": `mLIYMWnnvy0Gh0zrw9sW`,
	"actions": `YP_gCHz2COU9tV8uP1l0`,
	"nextButton": `OW9G6hSsDs87oIjLvKlL`,
	"preview": `hEFkrjyh19g1hOPaquZe`
};
export default ___CSS_LOADER_EXPORT___;
